import React from 'react';
import { View } from 'react-native-web';

const TopVerticalLine = ({
  globJSON,
}) => {
  const { colors } = globJSON.configurations.theme;
  return (
    <View style={{
      width: '100%',
      backgroundColor: colors.primary_cta_color,
      height: 3,
    }}
    />
  );
};
export default TopVerticalLine;
